import React from 'react';
import { IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox';
import { IBuyboxProps as IBuyboxExtentionProps } from '../../definition-extensions/buybox.ext.props.autogenerated';
import { IBuyboxData } from '../buybox.data';

export const BuyboxViewContext = React.createContext<IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData>>(
    {} as IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData>
);
